
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-apps",
      function () {
        return require("private-next-pages/our-apps/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-apps"])
      });
    }
  